module.exports = __webpack_public_path__ + "img/insta-w.455e784e.png";